// Top-of-page chrome: SJ logo + product name, current user, sign-in / sign-out,
// primary nav. Used as a layout wrapper around every authenticated route.
//
// Cosmetics live as inline `style={{...}}` per the codebase convention; layout
// and SJ-themed colors come from the .app-header / .app-header-* classes in
// styles.css (which are the only thing media queries can override).

import { Link, NavLink, Outlet } from 'react-router-dom';
import { hasRole, useAuth } from '../lib/auth';

export function AppShell() {
  const { user, login, logout, loading } = useAuth();

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="app-header-inner">
          <Link to="/" className="app-header-brand" aria-label="SJ Hub home">
            <span className="app-header-mark" aria-hidden="true">SJ</span>
            <span className="app-header-wordmark">SJ Hub</span>
          </Link>

          <nav className="app-header-nav">
            {user && (
              <NavLink to="/dashboard" className={navClass}>Dashboard</NavLink>
            )}
            {user && (
              <NavLink to="/invoices/new" className={navClass}>New invoice</NavLink>
            )}
            {hasRole(user, 'admin') && (
              <NavLink to="/admin/invoices" className={navClass}>Admin</NavLink>
            )}
          </nav>

          <div className="app-header-user">
            {loading ? (
              <span>...</span>
            ) : user ? (
              <>
                <span className="user-name">{user.displayName || user.email}</span>
                <button onClick={logout} style={btnGhostOnDark}>Sign out</button>
              </>
            ) : (
              <button onClick={login} style={btnPrimary}>Sign in</button>
            )}
          </div>
        </div>
      </header>
      <main className="app-shell-main">
        <Outlet />
      </main>
    </div>
  );
}

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : undefined);

const btnPrimary: React.CSSProperties = {
  padding: '8px 16px',
  fontSize: 14,
  fontWeight: 600,
  background: 'var(--sj-crimson)',
  color: '#fff',
  border: '1px solid var(--sj-crimson)',
  borderRadius: 999,
  cursor: 'pointer'
};

const btnGhostOnDark: React.CSSProperties = {
  padding: '8px 16px',
  fontSize: 14,
  fontWeight: 500,
  background: 'transparent',
  color: 'var(--sj-text-on-dark)',
  border: '1px solid var(--sj-line-dark)',
  borderRadius: 999,
  cursor: 'pointer'
};
